import type OverflowXHiddenStyles from './types';

const overflowXHidden: OverflowXHiddenStyles = {
    overflowX: 'hidden',
};

export default overflowXHidden;
